import { getSupabase, isSupabaseConfigured } from '../lib/supabase';
import { assertOnlineOrThrow } from '../lib/offlineGuard';

/**
 * 검색 상단 CPC 광고 — SECURITY DEFINER RPC (get_search_top_ads), ad_campaigns +
 * ad_placements(inventory_type='search_top') 기반. 카테고리 스코프 검색이면 target_category로,
 * 아니면 업체명 부분일치로 매칭.
 * @param {string} [query]
 * @param {string} [category]
 * @param {number} [limit]
 */
export async function fetchSearchTopAds(query, category, limit = 3) {
  if (!isSupabaseConfigured) return [];
  const sb = getSupabase();
  if (!sb) return [];

  try {
    assertOnlineOrThrow();
  } catch {
    return [];
  }

  const { data, error } = await sb.rpc('get_search_top_ads', {
    p_query: query || null,
    p_category: category || null,
    p_limit: limit,
  });

  if (error) {
    console.warn('[fetchSearchTopAds]', error.message || error);
    return [];
  }

  return (data || [])
    .filter((row) => row?.campaign_id && row?.business_id)
    .map((row) => ({
      id: String(row.campaign_id),
      businessId: String(row.business_id),
      name: row.name || '',
      category: row.category || '',
      region: row.region || '',
      image: row.image || '',
      rating: row.rating,
    }));
}
